import OrdersManagment from './OrdersManagment';
export default OrdersManagment;